document.querySelectorAll('.embed-card-wrapper, .card-preview_frame').forEach(card => {
    const version = card.id
    const frame = createIFrame(version)
    let isFirstTime
    document.querySelector('.blog-container').setAttribute("class", "card-preview-container")
    card.addEventListener('click', ()=>addIFrame (card, frame, isFirstTime))
})

function createIFrame(version) {
    const frame = document.createElement("IFRAME");
    const returnUrl = window.location.protocol + "//" + window.location.host + '/blog/cards/' + version
    frame.setAttribute("src", returnUrl);
    frame.setAttribute("id", "card-frame");
    frame.setAttribute("class", "card-preview_frame")
    frame.setAttribute("style", " border:none; padding:0; display: flex")
    return frame
}

function addIFrame(card, frame, isFirstTime) {
    const isBroken = document.querySelector("#isBroken").innerText
    card.parentNode.replaceChild(frame, card);
    (isBroken === 'true') ? setBrokenCardInterface(card, frame) : setCardInterface(card, frame);
    addOnloadEvent(frame, card, isFirstTime)
}

function setCardInterface(card, frame) {
    const cardInterface = document.querySelector('.card-interface')
    cardInterface.setAttribute("style", "display: block;")
    setBackButton(card, frame, cardInterface)
    setFullscreenButton(frame, cardInterface)
}

function setBrokenCardInterface(card, frame) {
    const cardInterface = document.querySelector('.card-interface')
    cardInterface.setAttribute("style", "width: 100%;; display: block;")
    setBackButton(card, frame, cardInterface)
    frame.parentNode.setAttribute("style", "z-index: 1; position: fixed; background: white; height: 100vh; top: 0; left:0; right:0;")
    document.querySelector('.fullscreen-button').style.display = 'none'
}

function setBackButton(card, frame, cardInterface) {
    const backButton =  document.querySelector('.back-button')
    backButton.addEventListener('click', ()=>{
        frame.parentNode.appendChild(card)
        frame.parentNode.setAttribute("style", "display: block; border:none; padding:0")
        frame.remove()
        cardInterface.setAttribute("style", "display: none; border:none; padding:0;")
        document.querySelector('.buttons-wrapper').setAttribute("style", "")
    })
}

function setFullscreenButton(frame, cardInterface) {
    const fullscreenButton = document.querySelector('.fullscreen-button')
    if(fullscreenButton.style.display === 'none'){
        fullscreenButton.setAttribute('style', "")
    }
    fullscreenButton.addEventListener('click', ()=>{
        swichMode(frame, fullscreenButton, cardInterface)
    })

}

function swichMode(frame, fullscreenButton, cardInterface){
    frame.parentNode.setAttribute("style", "z-index: 1; position: fixed; background: white; height: 100vh; top: 0; left:0; right:0;")
    cardInterface.setAttribute("style", "width: 100%; display: block;")
    fullscreenButton.setAttribute("style", "display: none;")
    document.querySelector('.buttons-wrapper').setAttribute("style", "right: 50px")
    frame.setAttribute("style", " border:none; padding:0; display: flex;")
}

function addOnloadEvent(frame, card, isFirstTime){
    let customClick = document.createEvent('MouseEvents')
    customClick.initMouseEvent('mousedown', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

    setTimeout (()=> {
        if(frame.contentDocument.querySelector('.play-button, .btn_play')){
            frame.contentDocument.querySelector('html').setAttribute("style", 'overflow-x: hidden;')
            if(isFirstTime){
                frame.contentDocument.querySelector('.play-button, .btn_play').dispatchEvent(customClick)
                isFirstTime = false
            }
        }else{
            addOnloadEvent(frame, card)
        }
    }, 250)
}
